import SPHP from './SPHP';

export default SPHP;
